/* 
 * Base Javascript for all pageloads.
 * 
 * Includes the Babel IE8 Pollyfill, jQuery, jQueryUI, Chosen, and Bootstrap
 */

import 'babel-polyfill'; // IE8 support
// require('jquery');

// import $ from 'jquery';
import 'jquery.browser'; // Required for backwards compatibility with jQuery < 1.9
import jQueryUI from 'jquery-ui-dist/jquery-ui';
import Chosen from 'chosen-js';

import MenuAim from 'jquery-menu-aim';

// Include boostrap javascript
import bootstrapModal from 'twbs/bootstrap-sass/assets/javascripts/bootstrap/modal';
import bootstrapDropdown from 'twbs/bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import bootstrapTab from 'twbs/bootstrap-sass/assets/javascripts/bootstrap/tab';
import bootstrapButton from 'twbs/bootstrap-sass/assets/javascripts/bootstrap/button';
import bootstrapCollapse from 'twbs/bootstrap-sass/assets/javascripts/bootstrap/collapse';

// Composer vendor JS includes
import mopaBootstrapCollection from 'mopa/bootstrap-bundle/Resources/public/js/mopabootstrap-collection.js';

// UMEM Style Libraries
import assets from '../scss/assets.scss';
import styles from '../scss/styles.scss';

// UMSOM layout libraries
import umsomSite from './umsom/umsom.site';

// UMEM JS Libraries
import form from './include/form';
import navigation from './include/navigation';
import fileCollection from './include/jquery.file-collection.js';

// Bundle JS includes
import event from 'EventBundle/Resources/assets/js/event';


$(function($) {
	umsomSite.ready();
});

/**
 *	Site-wide Javascript file. This is loaded on every page.
 */
$(document).ready(function() {

	// Setup alert highlight
	if( $('#alert') && $('#alert').length && $('#alert').innerHTML != '' ){
		$('#alert').effect('highlight', {}, 3000);
	}

});



// WEBPACK FOOTER //
// ./AppBundle/Resources/assets/js/default.js